VjsAdmin.DemoLicenses = (function () {
    const me = {};

    const $table = $('#licenses-table');
    const platformId = $table.attr('data-platform-id');
    me.include_usage = 0;
    me.date_range_from = null;
    me.date_range_to = null;
    me.order_by = 'license_id';
    me.sort_order = 'desc';
    me.search_status = 'active';

    const queryParams = function (params) {
        const myParams = VjsTable.tableDefaults().queryParams.call(this, params);

        myParams.demo_license = 1;

        myParams.sort_order = me.sort_order;
        myParams.order_by = me.order_by;
        myParams.active = 1;
        myParams.expire_in_days = null;
        myParams.activated_in_days = null;

        myParams.search_term = $('.fixed-table-toolbar .search > input').val();

        myParams.include_usage = me.include_usage;
        myParams.date_range_from = me.date_range_from == null ? null : me.date_range_from.format();
        myParams.date_range_to = me.date_range_to == null ? null : me.date_range_to.format();

        switch (me.search_status) {
            case 'all':
                myParams.active = null;
                break;
            case 'active':
                myParams.active = 1;
                break;
            case 'expired':
                myParams.active = 0;
                break;
            case 'expire-30':
                myParams.active = 1;
                myParams.expire_in_days = 30;
                break;
            case 'expire-60':
                myParams.active = 1;
                myParams.expire_in_days = 60;
                break;
            case 'expire-90':
                myParams.active = 1;
                myParams.expire_in_days = 90;
                break;
            case 'activate-30':
                myParams.active = 1;
                myParams.activated_in_days = 30;
                break;
            case 'activate-60':
                myParams.active = 1;
                myParams.activated_in_days = 60;
                break;
            case 'activate-90':
                myParams.active = 1;
                myParams.activated_in_days = 90;
                break;
            case 'exceeding-user-limit':
                myParams.active = 1;
                myParams.exceeding_user_limit = 1;
                break;
            case 'within-user-limit':
                myParams.active = 1;
                myParams.exceeding_user_limit = 0;
                break;
            default:
                break;
        }
        return myParams;
    };

    const vjsColumnsWithoutUsage = [
        {
            title: 'District',
            field: 'district_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Name',
            field: 'license_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'ID',
            field: 'license_id',
            align: 'center',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Active',
            field: 'active',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'State',
            field: 'state_code',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
            field: 'date_created',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
            field: 'date_modified',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
            field: 'activation_date',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
            field: 'expiration_date',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'User<br>Limit',
            field: 'user_account_limit',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Users',
            field: 'user_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Admins',
            field: 'admin_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Groups',
            field: 'group_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '',
            field: 'actions',
            align: 'center',
            valign: 'middle',
            sortable: true,
            switchable: false,
        },
    ];

    const vjsColumnsWithUsage = [
        [
            {
                title: 'District',
                field: 'district_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Name',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'ID',
                field: 'license_id',
                align: 'center',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Videos<br>Watched',
                field: 'videos_watched',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'QA Videos<br>Watched',
                field: 'videos_watched_qa',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Career<br>Journals',
                field: 'career_journals',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Assessments<br>Completed',
                field: 'assessments_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Résumés<br>Completed',
                field: 'resumes_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Quizzes<br>Completed',
                field: 'quiz_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
                field: 'activation_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
                field: 'expiration_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'User<br>Limit',
                field: 'user_account_limit',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Users',
                field: 'user_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Admins',
                field: 'admin_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Groups',
                field: 'group_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: true,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                switchable: false,
                sortable: false,
                colspan: 3,
                class: 'date-range-header',
            },
        ],
    ];

    const jrColumnsWithoutUsage = [
        {
            title: 'District',
            field: 'district_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'License',
            field: 'license_name',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'ID',
            field: 'license_id',
            align: 'center',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Active',
            field: 'active',
            align: 'center',
            valign: 'middle',
            visible: false,
            sortable: true,
        },
        {
            title: 'State',
            field: 'state_code',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
            field: 'date_created',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
            field: 'date_modified',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
            field: 'activation_date',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
            field: 'expiration_date',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'User<br>Limit',
            field: 'user_account_limit',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Users',
            field: 'user_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Admins',
            field: 'admin_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: 'Groups',
            field: 'group_count',
            align: 'left',
            valign: 'middle',
            sortable: true,
        },
        {
            title: '',
            field: 'actions',
            align: 'center',
            valign: 'middle',
            sortable: true,
            switchable: false,
        },
    ];

    const jrColumnsWithUsage = [
        [
            {
                title: 'District',
                field: 'district_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'License',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'ID',
                field: 'license_id',
                align: 'center',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Active',
                field: 'active',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                rowspan: 2,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Videos<br>Watched',
                field: 'videos_watched',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Cluster<br>Videos<br>Watched',
                field: 'videos_watched_cluster',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: 'Career<br>Videos<br>Watched',
                field: 'videos_watched_career',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: 'QA<br>Videos<br>Watched',
                field: 'videos_watched_career_qa',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: 'Logins',
                field: 'site_visits',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Time<br>Spent',
                field: 'time_spent',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Lessons<br>Completed',
                field: 'lessons_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: 'Assessments<br>Completed',
                field: 'assessments_complete',
                align: 'left',
                valign: 'middle',
                sortable: true,
                switchable: false,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                field: 'date_modified',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
                field: 'activation_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
                field: 'expiration_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'User<br>Limit',
                field: 'user_account_limit',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Users',
                field: 'user_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Admins',
                field: 'admin_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: 'Groups',
                field: 'group_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
                rowspan: 2,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: true,
                switchable: false,
                rowspan: 2,
            },
        ],
        [
            {
                title: 'Date Range',
                field: 'date_range',
                align: 'center',
                valign: 'middle',
                visible: false,
                switchable: false,
                sortable: false,
                colspan: 5,
                class: 'date-range-header',
            },
        ],
    ];

    const init = function () {
        me.order_by = $.urlParam('order_by') != null ? $.urlParam('order_by') : 'license_id';
        me.sort_order = $.urlParam('sort_order') != null ? $.urlParam('sort_order') : 'desc';
        me.search_status = $.urlParam('search_status') != null ? $.urlParam('search_status') : 'active';

        $('.demo-license-link').on('click', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');

            const form = $('<div>').html($('#demo-license-template').html());

            const submitButton = $('<button type="button" class="btn btn-green">Create</button>');
            const closeButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>');

            $(submitButton).on('click', (ee) => {
                ee.preventDefault();

                $modal.find('.modal-footer button').prop('disabled', true).html('Working... <i class="fa fa-spinner fa-pulse fa-fw"></i>');

                $('body').css('cursor', 'wait');

                let errors = false;
                if ($('#license_name').val() === '') {
                    $('#license_name').removeClass('is-valid').addClass('is-invalid');
                    errors = true;
                } else {
                    $('#license_name').removeClass('is-invalid').addClass('is-valid');
                }
                if ($('#city').val() === '') {
                    $('#city').removeClass('is-valid').addClass('is-invalid');
                    errors = true;
                } else {
                    $('#city').removeClass('is-invalid').addClass('is-valid');
                }
                if ($('#state_code').val() === '') {
                    $('#state_code').removeClass('is-valid').addClass('is-invalid');
                    errors = true;
                } else {
                    $('#state_code').removeClass('is-invalid').addClass('is-valid');
                }

                if (errors) {
                    $modal.find('.modal-footer button').prop('disabled', false).html('Create');
                    $('body').css('cursor', 'default');
                    return false;
                }

                $.post(href, $(form).find('form').serialize(), (response) => {
                    const { data } = response;

                    const licenseName = data.license_name;
                    const expirationDate = VjsAdmin.convertDate(data.expiration_date, 'MM/DD/YYYY');
                    const loginUrl = data.login_url;

                    const html = '<div class="alert alert-success" role="alert">Demo License Created!</div><br><br>'
                        + '<div class="card bg-light mb-3">'
                        + `<div class="card-header">${licenseName}</div class="card-header">`
                        + '  <div class="card-body">'
                        + '    <dl>'
                        + '      <dt>Expiration Date</dt>'
                        + `      <dd>${expirationDate}</dd>`
                        + '      <dt>Login URL</dt>'
                        + `      <dd>${loginUrl}</dd>`
                        + '    </dl>'
                        + '    <h3>Login Credentials:</h3>'
                        + '    <dl>'
                        + '      <dt>Username: Student</dt>'
                        + '      <dd>Password: junior</dd>'
                        + '      <dt>Username: Teacher</dt>'
                        + '      <dd>Password: junior</dd>'
                        + '      <dt>Username: SchoolAdmin</dt>'
                        + '      <dd>Password: junior</dd>'
                        + '    </dl>'
                        + '  </div>'
                        + '</div>';

                    $modal.find('.modal-body').html(html);
                    $modal.find('.modal-footer button').replaceWith(closeButton);
                    $table.bootstrapTable('refresh');
                    $('body').css('cursor', 'default');
                }).fail((jqXHR) => {
                    const response = jqXHR.responseJSON;
                    $modal.find('.modal-body .alert').remove();
                    $modal.find('.modal-body').prepend(`<div class="alert alert-danger" role="alert">Error: ${response.message}</div>`);
                    $modal.find('.modal-footer button').prop('disabled', false).html('Create');
                    $modal.find('.modal-body input').removeClass('is-invalid');
                    $.each(response.error.field_errors, (field) => {
                        $(`#${field}`).addClass('is-invalid');
                    });
                    $('body').css('cursor', 'default');
                });
            });

            const $modal = VjsAdmin.Modal.create({
                title: 'Create a VJSJunior.com Demo License',
                body: form,
                footer: submitButton,
            });

            $modal.modal();

            return false;
        });

        initTable();

        $('#search-status').on('change', () => {
            me.search_status = $('#search-status option:selected').val();
            $table.bootstrapTable('refresh');
        });
        $('.app-content').on('click', '#export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = queryParams.call($table.bootstrapTable('getOptions'));
            const visibleColumns = $table.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });

        $('.app-content').on('change', '#include-usage-stats', () => {
            const checked = $('.fixed-table-toolbar #include-usage-stats').prop('checked');

            if (checked) {
                const dateRangeForm = $('<div>').html($('#date-range-form-template').html());

                const $continueButton = $('<button type="button" class="btn btn-blue" data-dismiss="modal">Continue</button>');

                $continueButton.on('click', (e) => {
                    e.preventDefault();

                    let errors = false;
                    if ($('#date_range_from').val() === '') {
                        $('#date_range_from').removeClass('is-valid').addClass('is-invalid');
                        errors = true;
                    } else {
                        $('#date_range_from').removeClass('is-invalid').addClass('is-valid');
                    }
                    if ($('#date_range_to').val() === '') {
                        $('#date_range_to').removeClass('is-valid').addClass('is-invalid');
                        errors = true;
                    } else {
                        $('#date_range_to').removeClass('is-invalid').addClass('is-valid');
                    }

                    if (errors) {
                        return false;
                    }

                    return true;
                });

                const $modal = VjsAdmin.Modal.create({
                    id: 'include-usage-modal',
                    title: 'Choose Date Range for Usage Stats',
                    body: dateRangeForm,
                    footer: $continueButton,
                    onShown() {
                        $('#include-usage-modal .datetimepicker').each(function () {
                            $(this).datetimepicker({
                                useCurrent: false,
                                format: 'MM/DD/YYYY', // 'MM/DD/YYYY HH:mm',
                                icons: {
                                    date: 'fa fa-calendar',
                                    previous: 'fa fa-hand-o-left',
                                    next: 'fa fa-hand-o-right',
                                },
                            });
                        });
                    },
                    onHide() {
                        me.include_usage = 1;

                        if (
                            typeof $('#date_range_from').val() !== 'undefined'
                            && $('#date_range_from').val() !== null
                            && $('#date_range_from').val() !== ''
                        ) {
                            $('#date_range_from').val(moment($('#date_range_from').val()).utc().format());
                            me.date_range_from = moment($('#date_range_from').val()).utc();
                        }
                        if (
                            typeof $('#date_range_to').val() !== 'undefined'
                            && $('#date_range_to').val() !== null
                            && $('#date_range_to').val() !== ''
                        ) {
                            $('#date_range_to').val(moment($('#date_range_to').val()).utc().format());
                            me.date_range_to = moment($('#date_range_to').val()).utc();
                        }

                        $table.bootstrapTable('refreshOptions', {
                            columns: +platformId === 1 ? vjsColumnsWithUsage : jrColumnsWithUsage,
                        });
                        // $table.bootstrapTable('showColumn', 'site_visits');
                        // $table.bootstrapTable('showColumn', 'time_spent');
                        // $table.bootstrapTable('showColumn', 'videos_watched');
                        // $table.bootstrapTable('showColumn', 'lessons_complete');
                    },
                });
                $modal.modal();
            } else {
                me.include_usage = 0;
                $table.bootstrapTable('refreshOptions', {
                    columns: +platformId === 1 ? vjsColumnsWithoutUsage : jrColumnsWithoutUsage,
                });
                // $table.bootstrapTable('refresh');
                // $table.bootstrapTable('hideColumn', 'site_visits');
                // $table.bootstrapTable('hideColumn', 'time_spent');
                // $table.bootstrapTable('hideColumn', 'videos_watched');
                // $table.bootstrapTable('hideColumn', 'lessons_complete');
            }
        });
    };

    const initTable = function () {
        $table.addClass('loading');

        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#licenses-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                const activeStatus = me.search_status;
                let type = '';
                switch (activeStatus) {
                    case 'all':
                        type = 'licenses';
                        break;
                    case 'active':
                        type = '<strong>active</strong> licenses';
                        break;
                    case 'expired':
                        type = '<strong>expired</strong> licenses';
                        break;
                    default:
                        type = `licenses <strong>${$('#search-status option:selected').text()}</strong>`;
                        break;
                }
                return `No ${type}${
                    typeof searchTerm !== 'undefined' && searchTerm !== '' ? ` matching search term \`${SafeDOM.escapeHtml(searchTerm)}\`` : ''
                } in this district.`;
            },
            idField: 'license_id',
            toolbar: '#report-toolbar',
            toolbarAlign: 'left',
            sortName: me.order_by,
            sortOrder: me.sort_order,
            showColumns: true,
            url: Slim.Router.pathFor('platforms.demo-licenses.list.json', {
                platform_id: platformId,
            }),
            queryParams,
            columns: +platformId === 1 ? vjsColumnsWithoutUsage : jrColumnsWithoutUsage,
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(result, dateFormat, timeagoArray);

                    row.is_active = row.active;

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    row.time_spent = VjsAdmin.secondsToHoursMinutes(row.time_spent);

                    if (row.user_count > row.user_account_limit) {
                        row.user_account_limit += '<i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>';
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.list')) {
                        const licensesUrl = Slim.Router.pathFor('platforms.districts.licenses.list', {
                            platform_id: platformId,
                            district_joint_guid: row.district_joint_guid,
                        });
                        row.district_name = `<a href="${licensesUrl}">${row.district_name}</a>`;
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.view')) {
                        const statsUrl = Slim.Router.pathFor('platforms.districts.licenses.view', {
                            platform_id: platformId,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.license_name = `<a href="${statsUrl}">${row.license_name}</a>`;
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.users.list')) {
                        const usersUrl = Slim.Router.pathFor('platforms.districts.licenses.users.list', {
                            platform_id: platformId,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.user_count = `<a href="${usersUrl}?search_roles=users">${row.user_count}</a>`;
                        row.admin_count = `<a href="${usersUrl}?search_roles=admins">${row.admin_count}</a>`;
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.licenses.groups.list')) {
                        const groupsUrl = Slim.Router.pathFor('platforms.districts.licenses.groups.list', {
                            platform_id: platformId,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.group_count = `<a href="${groupsUrl}">${row.group_count}</a>`;
                    }

                    row.actions = '';
                    if (VjsAdmin.hasPermission('platforms.districts.licenses.edit.view')) {
                        const editLicenseUrl = Slim.Router.pathFor('platforms.districts.licenses.edit.view', {
                            platform_id: platformId,
                            district_joint_guid: row.district_joint_guid,
                            license_id: row.license_id,
                        });
                        row.actions += `<a href="${editLicenseUrl}" class="btn btn-hollow-blue">Edit</a>`;
                    }
                });
                return formattedResult;
            },
            onLoadSuccess(data) {
                VjsTable.tableDefaults().onLoadSuccess.call(this, data);
                if (
                    typeof me.date_range_from !== 'undefined'
                    && me.date_range_from != null
                    && typeof me.date_range_to !== 'undefined'
                    && me.date_range_to != null
                ) {
                    $table.find('th.date-range-header').text(`${me.date_range_from.format('l')} to ${me.date_range_to.format('l')}`);
                } else if (typeof me.date_range_from !== 'undefined' && me.date_range_from != null) {
                    $table.find('th.date-range-header').text(`${me.date_range_from.format('l')} to Now`);
                }
            },
            onSort(name, order) {
                VjsTable.tableDefaults().onSort.call(this, name, order);
                me.order_by = name;
                me.sort_order = order;
            },
            onColumnSwitch() {
                $table.bootstrapTable('refresh');
            },
        });
    };

    return {
        init,
    };
}());
